module.exports = __webpack_public_path__ + "static/img/brand-first-4.c954f844.png";